// extracted by mini-css-extract-plugin
export default {"boxPreview":"NameplatePreview_boxPreview__ifUV+","imagePreview":"NameplatePreview_imagePreview__Dd3J2"};